import React from 'react';

import {
  Tooltip,
} from 'web-components';

import {
  icons,
  SVG,
} from 'web-styled';

import StyledIcon from './styled';

type Props = {
  id: string;
  index?: number;
  tooltip: string;
  isActive: boolean;
  isCompleted: boolean;
  onClick: { (): void };
};

const Step = ({
  id,
  index,
  tooltip,
  isActive,
  isCompleted,
  onClick,
}: Props) => {
  const renderIcon = () => {
    if (index) {
      return (
        <span>{index}</span>
      );
    }

    return {
      add_client: (
        <SVG.Clients stroke={isActive ? '#ffffff' : '#757575'} />
      ),
      assign_workout: (
        <SVG.KettleBell stroke={isActive ? '#ffffff' : '#757575'} />
      ),
      add_exercise: (
        <SVG.Exercise stroke={isActive ? '#ffffff' : '#757575'} />
      ),
      review_documents: (
        <SVG.Document stroke={isActive ? '#ffffff' : '#757575'} />
      ),
      build_your_own_workout: (
        <SVG.Program stroke={isActive ? '#ffffff' : '#757575'} />
      ),
      got_questions: (
        <SVG.GotQuestion fill={isActive ? '#ffffff' : '#757575'} />
      ),
    }[id];
  };

  const Icon = () => (
    <StyledIcon
      isActive={isActive}
      isCompleted={isCompleted}
      onClick={onClick}
    >
      <img src={icons.check} alt="" />
      {renderIcon()}
    </StyledIcon>
  );

  if (tooltip) {
    return (
      <Tooltip
        body={tooltip}
        positions={['top']}
      >
        <div>
          <Icon />
        </div>
      </Tooltip>
    );
  }

  return (<Icon />);
};

Step.defaultProps = {
  index: undefined,
};

export default Step;
